import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mb-4",attrs:{"id":"page-header"}},[_c(VRow,{attrs:{"align":"center"}},[_c(VSpacer),_c(VCol,{attrs:{"cols":"auto"}},[_c('portal-target',{attrs:{"name":"headerFilters","slim":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }